import React from 'react';

// In-app version of the Novalink loading screen from index.html (styles in theme.css).
export default function NovaLoader({ label = 'Loading NovaBotX' }) {
  const base = import.meta.env.BASE_URL;
  return (
    <div className="nb-loader" role="status" aria-label={label}>
      <div className="nb-loader-logo">
        <div className="nb-loader-planet-wrap">
          <span className="nb-loader-glow" />
          <span className="nb-loader-orbit" />
          <img className="nb-loader-planet" src={`${base}assets/novalink-planet.png`} alt="" />
        </div>
        <img className="nb-loader-word" src={`${base}assets/novalink-wordmark.png`} alt="Novalink Solutions" />
      </div>
      <div className="nb-loader-bar"><span /></div>
      <p className="nb-loader-text">{label}</p>
    </div>
  );
}
